import { NetworkErrorCode, NetworkErrorName } from './error.types';

export class BaseNetworkError extends Error {
  public readonly message: string;
  public readonly code: NetworkErrorCode;
  public readonly data: any;

  constructor(
    message: string,
    code: NetworkErrorCode,
    name: NetworkErrorName = NetworkErrorName.NETWORK_ERROR,
    response: any = null
  ) {
    super(message);
    this.message = message;
    this.code = code;
    this.name = name;
    this.data = response;
  }
}
